import React from "react";
import { FaCalendarAlt } from "react-icons/fa";
import { GiBlackBelt } from "react-icons/gi";

import {
  formatGradeDate,
  getBeltImage,
  getBeltName,
} from "../utils/passageGradeUtils";

function CurrentBeltCard({ lastGrade }) {
  if (!lastGrade) {
    return (
      <article className="rounded-[2rem] border border-dashed border-slate-300 bg-white p-6 text-center shadow-xl shadow-slate-200/60 dark:border-white/10 dark:bg-white/[0.05] dark:shadow-black/20">
        <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-[1.5rem] bg-slate-100 text-slate-500 dark:bg-white/10 dark:text-white/60">
          <GiBlackBelt className="text-2xl" />
        </div>

        <h2 className="mt-4 font-titre text-2xl font-bold text-slate-950 dark:text-white">
          Aucune ceinture renseignée
        </h2>

        <p className="mt-2 text-sm font-medium leading-6 text-slate-500 dark:text-white/50">
          Ajoute le premier passage de grade pour afficher la ceinture actuelle.
        </p>
      </article>
    );
  }

  const beltImage = getBeltImage(lastGrade);

  return (
    <article className="overflow-hidden rounded-[2rem] border border-slate-200 bg-white shadow-xl shadow-slate-200/60 dark:border-white/10 dark:bg-white/[0.05] dark:shadow-black/20">
      <div className="bg-gradient-to-br from-slate-950 via-orange-950 to-orange-600 p-5 text-white">
        <div className="flex items-center justify-between gap-4">
          <div>
            <p className="text-xs font-bold uppercase tracking-[0.16em] text-white/55">
              Grade actuel
            </p>

            <h2 className="mt-2 font-titre text-3xl font-bold">
              {getBeltName(lastGrade)}
            </h2>

            <p className="mt-2 inline-flex items-center gap-2 text-sm font-medium text-white/70">
              <FaCalendarAlt />
              {formatGradeDate(lastGrade.date_passage)}
            </p>
          </div>

          <div className="flex h-20 w-20 shrink-0 items-center justify-center rounded-[1.5rem] bg-white/15 backdrop-blur-xl">
            <GiBlackBelt className="text-4xl" />
          </div>
        </div>
      </div>

      <div className="p-5">
        {beltImage ? (
          <img
            src={beltImage}
            alt={getBeltName(lastGrade)}
            className="mx-auto h-24 w-full object-contain"
          />
        ) : (
          <div className="flex h-24 items-center justify-center rounded-[1.5rem] bg-slate-100 text-sm font-bold text-slate-500 dark:bg-white/10 dark:text-white/50">
            Image de ceinture non disponible
          </div>
        )}
      </div>
    </article>
  );
}

export default CurrentBeltCard;